import { toastr } from "react-redux-toastr";
import { BONUSES_ACTION_TYPES } from "./actionTypes";
import { bonusesApi } from "./api";

export const bonusesActions = {
    fetchRequest: () => ({
        type: BONUSES_ACTION_TYPES.FETCH_REQUEST,
    }),

    fetchSuccess: (data) => ({
        type: BONUSES_ACTION_TYPES.FETCH_SUCCESS,
        payload: data,
    }),

    fetchFailure: (error) => ({
        type: BONUSES_ACTION_TYPES.FETCH_FAILURE,
        payload: { error },
        error: true,
    }),

    applyRequest: () => ({
        type: BONUSES_ACTION_TYPES.APPLY_REQUEST,
    }),

    applySuccess: (data) => ({
        type: BONUSES_ACTION_TYPES.APPLY_SUCCESS,
        payload: data,
        meta: { timestamp: Date.now() },
    }),

    applyFailure: (error) => ({
        type: BONUSES_ACTION_TYPES.APPLY_FAILURE,
        payload: { error },
        error: true,
    }),

    clearPoints: () => ({
        type: BONUSES_ACTION_TYPES.CLEAR_POINTS,
    }),
};

export const fetchBonuses = () => {
    return async (dispatch, getState) => {
        const state = getState();
        const token = state.auth?.token;

        if (!token || state.bonuses?.loading) {
            return;
        }

        dispatch(bonusesActions.fetchRequest());

        try {
            const data = await bonusesApi.fetchBonuses(token);
            dispatch(bonusesActions.fetchSuccess(data));
            return data;
        } catch (error) {
            console.error('Fetch bonuses error:', error);
            dispatch(bonusesActions.fetchFailure(error.message));
        }
    };
};

export const applyBonusPoints = (cartTotal) => {
    return async (dispatch, getState) => {
        const state = getState();
        const token = state.auth?.token;

        if (state.bonuses?.applying) {
            return;
        }

        if (!token) {
            toastr.warning('Внимание', 'Войдите в аккаунт, чтобы списать баллы');
            return;
        }

        if (!cartTotal || cartTotal <= 0) {
            toastr.warning('Внимание', 'Корзина пуста');
            return;
        }

        dispatch(bonusesActions.applyRequest());

        try {
            const result = await bonusesApi.applyPoints(cartTotal, token);

            if (result.success) {
                const available = state.bonuses?.info?.wallet_points_active || 0;
                const discount = result.amount > 0
                    ? result.amount
                    : Math.min(available, cartTotal);

                dispatch(bonusesActions.applySuccess({
                    coupon: result.coupon,
                    discount,
                    cartTotal,
                }));
                toastr.success('Баллы списаны', `Скидка: ${Number(discount).toLocaleString()}₽`);
            } else {
                dispatch(bonusesActions.applyFailure(result.message));
                toastr.warning('Бонусы', result.message);
            }

            return result;
        } catch (error) {
            console.error('Apply bonus points error:', error);
            dispatch(bonusesActions.applyFailure('Ошибка при списании баллов'));
            toastr.error('Ошибка', 'Не удалось списать баллы');
        }
    };
};

export const clearBonusPoints = (silent = false) => {
    return (dispatch) => {
        dispatch(bonusesActions.clearPoints());
        if (!silent) {
            toastr.info('Бонусы', 'Списание баллов отменено');
        }
    };
};
